// extracted by mini-css-extract-plugin
module.exports = {"opportunityBarWrapper":"opportunityBarWrapper___2oXv5","type":"type___2CjMS","details":"details___15A-A","colItem":"colItem___2duRk"};